// extracted by mini-css-extract-plugin
export default {"button":"GenericButton_button__Gegsl","active":"GenericButton_active__vyXwe"};